const toTop = document.querySelectorAll('[data-scroll="top"]');

toTop.forEach(function(element) {
    element.addEventListener('click', function() {
        scrollToTop(800);
    });
})

function scrollToTop(scrollDuration) {
    const scrollStep = -window.scrollY / (scrollDuration / 15),
    scrollInterval = setInterval(function() {
        if (window.scrollY != 0) {
            window.scrollBy(0, scrollStep);
        }
        else clearInterval(scrollInterval);
    },15);
}

export default scrollToTop;
